import {REQUEST_GET} from '/enum/request.enum';

import {FirebasePerfMonitorBackend} from './perf-monitor-firebase';

// Set this to `true` to enable console logging of analytic events.
// Do NOT commit that change into the repo.
const LOG_PERF_METRIC = false;

export class PerformanceMonitor {
  backend: any;

  constructor({backend}: any) {
    this.backend = backend;
  }

  getNetworkMetric = ({
    url,
    method = REQUEST_GET,
    payloadSize = 0,
  }: any = {}) => {
    return this.backend.getHttpMetric({url, method, payloadSize});
  };

  enableDataCollection = () => {
    this.backend.setPerformanceCollectionEnabled(true);
  };

  disableDataCollection = () => {
    this.backend.setPerformanceCollectionEnabled(false);
  };
}

let PerfMonitorDefaultInstance: any = null;

export const getPerfMonitorDefaultInstance = () => {
  if (PerfMonitorDefaultInstance === null) {
    PerfMonitorDefaultInstance = new PerformanceMonitor({
      backend: new FirebasePerfMonitorBackend({verbose: LOG_PERF_METRIC}),
    });
  }

  return PerfMonitorDefaultInstance;
};
